export default "__VITE_ASSET__DLRhidUj__"